import { useQuery } from '@tanstack/react-query'
import apiClient from '@/lib/api/client'
import { range as sdkGetReports } from '@/lib/api/generated/sdk.gen'

declare const __VITE_API_BASE__: string;

export interface ReportsParams {
  startDate: string
  endDate: string
  dimension?: 'hour' | 'day' | 'week' | 'month'
  type?: string
}

export interface ReportData {
  sending: {
    timeline: Array<{
      date: string
      sent: number
      success: number
      failed: number
      cost: number
      successRate: number
    }>
    summary: {
      totalSent: number
      totalSuccess: number
      totalFailed: number
      totalCost: number
      avgSuccessRate: number
    }
    typeDistribution: Array<{
      type: string
      count: number
      percentage: number
    }>
  }
  template: {
    usage: Array<{
      templateId: string
      templateName: string
      usage: number
      successRate: number
      cost: number
    }>
  }
  cost: {
    timeline: Array<{
      date: string
      cost: number
      count: number
      avgCost: number
    }>
    breakdown: Array<{
      type: string
      cost: number
      percentage: number
    }>
  }
}

// 获取报表数据
export const useReports = (params: ReportsParams) => {
  return useQuery({
    queryKey: ['reports', params],
    queryFn: async (): Promise<ReportData> => {
      const res: any = await sdkGetReports({ client: apiClient, responseStyle: 'fields', throwOnError: false, query: params as any })
      const payload: any = (res as any)?.data ?? res
      return payload as ReportData
    },
    staleTime: 5 * 60 * 1000, // 5分钟内不重新请求
  })
}

// 导出报表
export const useExportReports = () => {
  return async (params: ReportsParams & { format: 'excel' | 'csv' | 'pdf' }) => {
    // 简化：占位，无真实导出接口
    const response = await fetch(`${__VITE_API_BASE__ || ''}/api/v1/tenant/reports`, { credentials: 'include' })
    
    // 创建下载链接
    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `reports_${params.startDate}_${params.endDate}.${params.format}`)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  }
}